import React from 'react'
import { t as typy } from 'typy'

import Image from 'src/components/UI/Image/Image'

import styles from './Footer.module.scss'

type Props = {
  methods: []
  wrapperStyles?: any
}

const PaymentMethods = ({ methods, wrapperStyles }: Props) => (
  <div className={wrapperStyles}>
    {methods.map((payment: any, index: number) =>
      typy(payment, 'fields.file.url').safeObject ? (
        <Image
          className={styles.payment}
          key={'payment' + index}
          src={typy(payment, 'fields.file.url').safeObject}
          alt={typy(payment, 'fields.title').safeObject}
        />
      ) : null
    )}
  </div>
)

export default PaymentMethods
